import React, { FC } from 'react';
import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { TypeUserRecord } from '@/lib/api/accountManager/types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeAccountSettingsPageTranslations } from '@/utils/translations/types/TypeAccountSettingsPageTranslations';

export type ContactDetailsTileProps = {
  t: TypeAccountSettingsPageTranslations;
  user: TypeUserRecord;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
};

const ContactDetailsTile: FC<ContactDetailsTileProps> = ({
  t,
  user,
  tile,
  locale,
}) => {
  function UserDisplay() {
    return (
      <>
        <div className="mb-2 flex flex-row gap-4">
          <p className="font-bold">{t.nameLabel}</p>
          <p>{`${user.first_name} ${user.last_name}`}</p>
        </div>
        <div className="flex flex-row gap-4">
          <p className="font-bold">{t.emailLabel}</p>
          <p className="break-all">{user.email}</p>
        </div>
      </>
    );
  }

  const editUserLink = constructLegacyCustomerPortalLink(locale, [
    user.uuid,
    'profile-info',
    'edit-contact-details',
  ]);

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={<GenExternalLink href={editUserLink} cta={t.editCta} />}
    >
      <UserDisplay />
    </GenNavTile>
  );
};

export default React.memo(ContactDetailsTile);
